import axios from "axios";
import { useCallback } from "react";
import { useAuth } from "@/lib/auth";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useApi() {
  const { getToken } = useAuth();
  return useCallback(
    async (method, path, data, opts = {}) => {
      const token = await getToken();
      const res = await axios({
        method,
        url: `${API}${path}`,
        data,
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        ...opts,
      });
      return res.data;
    },
    [getToken]
  );
}

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg?.replace("Value error, ", "")).join(", ");
  return d.message || "Something went wrong";
};

export const errCode = (e) => e?.response?.data?.detail?.code;

export async function fetchBlob(api, path) {
  const data = await api("get", path, undefined, { responseType: "blob" });
  return URL.createObjectURL(data);
}

export async function downloadFile(api, path, filename) {
  const url = await fetchBlob(api, path);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 4000);
}

export const fmtDate = (d) =>
  d ? new Date(`${d}T00:00:00`).toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" }) : "—";

export const fmtBytes = (b) => (b > 1048576 ? `${(b / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round(b / 1024))} KB`);
